import type { ColumnDef } from "@tanstack/react-table";
import type { ApVendor } from "@/accounts-payable/types";

// The first address says who this is; the rest are counted.
export const aliasesCol: ColumnDef<ApVendor> = {
  id: "aliases",
  header: "Email aliases",
  meta: { size: "280px" },
  cell: ({ row }) => {
    const [first, ...rest] = row.original.email_aliases;
    if (!first) return <span className="text-tertiary-text">None</span>;
    return (
      <span
        className="block truncate"
        title={row.original.email_aliases.join(", ")}
      >
        {first}
        {rest.length > 0 && (
          <span className="text-tertiary-text"> +{rest.length} more</span>
        )}
      </span>
    );
  },
};
